<a-icon v-if="icon" :icon="iconLocal" :class="iconClass" v-bind="iconAttributes" v-translate="translateOptions"><slot></slot></a-icon>